export default __webpack_public_path__ + "static/media/event-border-hover.6ebc311c.webp";